import { getReminderStageLabel } from "@/lib/utils/reminder-stage-label";
import { PdfTemplateType } from "../../../../pdf-templates/document-template.types";

export type ReminderTemplateType =
	| PdfTemplateType.ZAHLUNGSERINNERUNG
	| PdfTemplateType.ERSTE_MAHNUNG
	| PdfTemplateType.FOLGEMAHNUNG
	| PdfTemplateType.LETZTE_MAHNUNG;

export const MAX_REMINDER_STAGE = 4;

// The Zahlungserinnerung (stage 1) is free; fees start with the 1. Mahnung.
export const FIRST_FEE_STAGE = 2;

export function isReminderTemplateType(
	templateType: PdfTemplateType
): templateType is ReminderTemplateType {
	return (
		templateType === PdfTemplateType.ZAHLUNGSERINNERUNG ||
		templateType === PdfTemplateType.ERSTE_MAHNUNG ||
		templateType === PdfTemplateType.FOLGEMAHNUNG ||
		templateType === PdfTemplateType.LETZTE_MAHNUNG
	);
}

export function getReminderTemplateType(
	stage: number,
	maxStage: number
): ReminderTemplateType {
	if (stage <= 1) return PdfTemplateType.ZAHLUNGSERINNERUNG;
	if (stage >= maxStage) return PdfTemplateType.LETZTE_MAHNUNG;
	if (stage === 2) return PdfTemplateType.ERSTE_MAHNUNG;
	return PdfTemplateType.FOLGEMAHNUNG;
}

export function getReminderActionLabel(nextStage: number): string {
	return `${getReminderStageLabel(nextStage)} erstellen`;
}

export const REMINDER_TEMPLATE_LABELS: Record<ReminderTemplateType, string> = {
	[PdfTemplateType.ZAHLUNGSERINNERUNG]: "Zahlungserinnerung",
	[PdfTemplateType.ERSTE_MAHNUNG]: "Erste Mahnung",
	[PdfTemplateType.FOLGEMAHNUNG]: "Folgemahnung",
	[PdfTemplateType.LETZTE_MAHNUNG]: "Letzte Mahnung",
};
